<template>
	<div class="UserAddressInfo">
		<van-cell-group class="self">
			<van-field
				v-model.trim="adrInfo.name"
				label="姓名："
				placeholder="请输入姓名"
			required
				clearable
			></van-field>
			<van-field
				v-model.trim="adrInfo.telphone"
				type="tel"
				label="电话："
				required
				placeholder="请输入电话"
				clearable
			></van-field>
			<van-cell
				@click="showPicker=!showPicker"
				title="所在地区："
				required
				is-link
				:value="adrInfo.area"
				title-class="van-cell-title"
			></van-cell>
			<van-field
				v-model.trim="adrInfo.address"
				label="街道地址："
				required
				placeholder="请输入详细地址"
				clearable
			@blur="locationAmapByAddress(adrInfo.address)"
			></van-field>
			<div id="amap_container_ads" class="amap_container"></div>
			<van-cell title="设为默认地址">
				<van-switch v-model="defAddressSwitch"/>
			</van-cell>
		</van-cell-group>

		<van-button type="primary" block  @click="saveAddress()" >保存</van-button>

		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="areaColumns"
			@cancel="showPicker = false"
			@confirm="onAreaConfirm"
		  />
		</van-popup>
	</div>
</template>
<script>
export default {
	name: "UserAddressInfo",
	props:{
		adrInfo:Object
	},
	data() {
		return {
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id")+"token"),
			areaColumns:JSON.parse(localStorage.getItem("area_districts")),
			amap:{},
			amapGeocoder:{},
			amapMarker:false,
			showPicker:false,
			defAddressSwitch:false,
			preAddress:''
		};
	},
	methods: {
		onAreaConfirm(value, index) {
			this.showPicker = false;
			this.adrInfo['area'] = value.join("")
			this.initAmapByCity(value.join(""))
		},
		initAmapByCity(cityad){
			this.amapGeocoder = new AMap.Geocoder({
				city:''//cityad
			});
			this.locationAmapByAddress(cityad)
		},
		markerAmap(lnglat,reset){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
			this.adrInfo['lng'] = lnglat[0];
			this.adrInfo['lat'] = lnglat[1];
			if(reset){
				this.resetAddressByLnglat(lnglat);
			}
		},
		resetAddressByLnglat(lnglat){
			var geocoder = new AMap.Geocoder({
				city: ''
			})
			let that = this;
			geocoder.getAddress(lnglat, function (status, data) {
				if (status === 'complete' && data.info === 'OK') {
					// result为对应的地理位置详细信息
					//console.log(data)
					let faddress = data.regeocode.formattedAddress;
					let acomp = data.regeocode.addressComponent;
					let district = acomp.district;
					if(!(that.adrInfo.area && that.adrInfo.area.indexOf(district) > -1)){
						that.adrInfo.area = acomp.province+acomp.city+district;
					}
					let fadr = faddress.split(district);
					that.$delete(fadr, 0);
					that.adrInfo.address = fadr.join(district);
					that.$forceUpdate();
				}
			})

		},
		locationAmapByAddress(ads){
			if(ads && this.preAddress != ads){
				let that = this;
				this.amapGeocoder.getLocation(ads, function(status, result) {
					if (status === 'complete'&&result.geocodes.length) {
						let local = result.geocodes[0].location;
						that.markerAmap([local.lng, local.lat],0);
					}else{
						that.$toast.fail("地址定位失败，请手动指定");
					}
				});
			}
		},
		saveAddress(){
			if(!this.adrInfo['name']){
				this.$toast.fail("请输入姓名！");
				return false;
			}
			if(!this.adrInfo['telphone']){
				this.$toast.fail("请输入联系电话！");
				return false;
			}
			if(!this.adrInfo['area']){
				this.$toast.fail("请选择所在地区！");
				return false;
			}
			if(!this.adrInfo['address']){
				this.$toast.fail("请填写街道地址！");
				return false;
			}
			if(!this.adrInfo['lng'] || !this.adrInfo['lat']){
				this.$toast.fail("请在地图上标记位置！");
				return false;
			}
			if(this.u_id && this.token){
				this.adrInfo['u_id'] = this.u_id;
				var params = {
					u_id:this.u_id,
					token:this.token,
					address:this.adrInfo
				};
				params.address.defaults = this.defAddressSwitch?1:0;
				let that = this;
				var url = this.Conf.serverUrl + "User/saveAddress" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.$emit("callAfterSave");
					}
				})
				.catch(error => {});
			}else{
				that.$emit("callAfterSave", this.adrInfo);
			}
		}
	},
	created() {
		this.defAddressSwitch = this.adrInfo?(this.adrInfo.defaults==1):false;
		this.preAddress = this.adrInfo?this.adrInfo.address:'';
		let that = this;
		this.$nextTick(() => {
			that.amap = new AMap.Map("amap_container_ads", {
				resizeEnable: true
			});
			that.amap.on('click', function(e) {
				that.markerAmap([e.lnglat.getLng(), e.lnglat.getLat()],1);
			});
			if(that.adrInfo && that.adrInfo.lng && that.adrInfo.lat){
				that.markerAmap([that.adrInfo.lng, that.adrInfo.lat],0);
			}
		});
	}
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/User/UserAddressInfo.vue